<template>
	<div>
		<div v-if="isDataLoaded" id="manage-billing-page">
			
<!--			<h2>Subscription for {{organizationName}}</h2>-->
<!--			<div>-->
<!--				<a href="#" @click="switchToPrevious" :style="isPreviousSubscription ? 'color: black' : ''">PREVIOUS</a> |-->
<!--				<a href="#" @click="switchToCurrent" :style="!isPreviousSubscription && !isUpcomingSubscription ? 'color: black' : ''">CURRENT</a> |-->
<!--				<a href="#" @click="switchToUpcoming" :style="isUpcomingSubscription ? 'color: black' : ''">UPCOMING</a>-->
<!--			</div>-->
<!--			-->
<!--			<br />-->
			<v-alert
				type="info"
				text
				v-if="billToOrgId && $store.getters.isSuperAdmin"
			>
				<strong>{{superAdminSymbol}} Billing Parent Org: {{billToOrgName}} ({{billToOrgId}})</strong>
				<div style="font-size: .9rem">
					This organization has a Billing Parent Organization meaning it most likely <strong>does not</strong> need its own subscription.
				</div>
			</v-alert>
			
			
			<br />
            <AppCard v-if="!$store.getters.isSuperAdmin && allSportsSubscriptions.data.length < 1 && allClinicalSubscriptions.data.length < 1" hide-header >
                <div class="pa-4">
                    <div style="display: flex">
                        <h3>Subscription</h3>
                        <v-spacer></v-spacer>
                    </div>
                    <div>Please contact Sway for more details about your subscription.</div>
                </div>
            </AppCard>
			<AppCard v-else hide-header >
				<div class="pa-4">
					<div style="display: flex">
						<h3>Sports Subscription</h3>
						<v-spacer></v-spacer>
                        <div style="padding: 0px 1rem; color: rgb(34, 34, 34); max-width:500px">Please email <a href="mailto:billing@swaymedical.com" style="color: blue;">billing@swaymedical.com</a> if you would like us to send your new invoice now.</div>
						<AppButton v-if="$store.getters.isSuperAdmin" @click="createSportsSubscriptionDialogOpen = true" icon="mdi-plus" color="green">{{superAdminSymbol}} Add Sports Subscription</AppButton>
					</div>
					<div v-if="allSportsSubscriptions.data.length < 1">There are currently no sports subscriptions for this organization.</div>
				</div>
				<div v-if="allSportsSubscriptions.data.length > 0">
					<app-tabs :value="currentSportsTab" underline :margin-bottom="false">
						<app-tab
							v-for="(tab, index) in sportsTabs"
							:key="index"
							@click="currentSportsTab = index"
							:icon="tab.icon"
						>{{ tab.label }}</app-tab>
					</app-tabs>
					<div >
						<div v-if="currentSportsTab === 0">
							<v-data-table
								:items="allSportsSubscriptions.data"
								:headers="allSportsSubscriptionsTableHeaders"
								id="sports-subscriptions-table"
								item-key="productSubscriptionId"

								:sort-by="[{ key: 'startDate.value', order: 'desc' }]"
							>
								<template v-slot:item.productSubscriptionId="{item}">
									{{item.productSubscriptionId}}
									<AppChip v-if="item.isCurrent" color="green" small label class="ml-2" outlined>Current</AppChip>
									<AppChip v-if="item.isFuture" color="blue" small label class="ml-2" outlined>Future</AppChip>
									<AppChip v-if="item.issues.doesOverlap" color="red" small label class="ml-2">OVERLAP</AppChip>
								
								</template>
								<template v-slot:item.displayName="{item}">
									<AppChip :color="item.color.chip" small label>{{item.displayName}}</AppChip>
								
								</template>
								<template v-if="$store.getters.isSuperAdmin" v-slot:item.actions="{ item }">
									<v-icon
										small
										class="mr-2"
										@click="editSportsSubscription(item)"
									>
										mdi-pencil
									</v-icon>
                                    <v-icon
                                        small
                                        class="mr-2"
                                        @click="deleteSubscription(item)"
                                    >
                                        mdi-delete
                                    </v-icon>
                                    <v-icon
                                        small
                                        @click="createSubscriptionInvoice(item)"
                                    >
                                        mdi-invoice-text-plus
                                    </v-icon>
								</template>
							</v-data-table>
						</div>
						<div v-else>
							<highcharts :options="allSportsSubscriptions.subscriptionChart" ref="highchart" />
						</div>
					</div>
					
				</div>
				
			</AppCard>
			
			<AppCard v-if="allClinicalSubscriptions.data.length >= 1 || $store.getters.isSuperAdmin" hide-header class="mt-4">
				<div class="pa-4">
					<div style="display: flex">
						<h3>Clinical Subscription</h3>
						<v-spacer></v-spacer>
						<AppButton
							@click="createClinicalSubscriptionDialogOpen = true" 
							icon="mdi-plus" 
							color="purple"
                            v-if="$store.getters.isSuperAdmin"
						>
							{{superAdminSymbol}} Add Clinical Subscription
						</AppButton>
						
					</div>
					<div v-if="allClinicalSubscriptions.data.length < 1">There are currently no clinical subscriptions for this organization.</div>
				</div>
				<div v-if="allClinicalSubscriptions.data.length > 0">
					<app-tabs :value="currentClinicalTab" underline :margin-bottom="false">
						<app-tab
							v-for="(tab, index) in sportsTabs"
							:key="index"
							@click="currentClinicalTab = index"
							:icon="tab.icon"
						>{{ tab.label }}</app-tab>
					</app-tabs>
					<div>
						<div v-if="currentClinicalTab === 0">
							<v-data-table
								:items="allClinicalSubscriptions.data"
								:headers="allClinicalSubscriptionsTableHeaders"
								id="clinical-subscriptions-table"
								item-key="productSubscriptionId"
								:sort-by="[{ key: 'startDate.value', order: 'desc' }]"
							>
								<template v-slot:item.productSubscriptionId="{item}">
									{{item.productSubscriptionId}}
									<AppChip v-if="item.isCurrent" color="green" small label class="ml-2" outlined>Current</AppChip>
									<AppChip v-if="item.isFuture" color="blue" small label class="ml-2" outlined>Future</AppChip>
									<AppChip v-if="item.issues.doesOverlap" color="red" small label class="ml-2">OVERLAP</AppChip>
								
								
								</template>
								<template v-slot:item.displayName="{item}">
									<AppChip :color="item.color.chip" small label>{{item.displayName}}</AppChip>
								
								</template>
								<template v-slot:item.profileCount="{item}">
									<template v-if="item.isPrePaid">{{item.totalProfileCount.display}}</template>
									<template v-else>Post-Paid (Legacy)</template>
								</template>
								<template v-if="$store.getters.isSuperAdmin" v-slot:item.actions="{ item }">
									<v-icon
										small
										class="mr-2"
										@click="editClinicalSubscription(item)"
									>
										mdi-pencil
									</v-icon>
                                    <v-icon
                                        small
                                        class="mr-2"
                                        @click="deleteSubscription(item)"
                                    >
                                        mdi-delete
                                    </v-icon>
                                    <v-icon
                                        small
                                        @click="createSubscriptionInvoice(item)"
                                    >
                                        mdi-invoice-text-plus
                                    </v-icon>
								</template>
							</v-data-table>
						</div>
						<div v-else>
							<highcharts :options="allClinicalSubscriptions.subscriptionChart" ref="highchart" />
						</div>
					</div>
				</div>
				
			</AppCard>
			
			<DialogForm
				title="Create Sports Subscription"
				:open="createSportsSubscriptionDialogOpen"
				@close="createSportsSubscriptionDialogOpen = false"
				@submit="() => updateProductSubscriptionById(newSportsSubscriptionForm)"
				:saving="savingSubscription"
			>
                <template v-slot:form-content>
                    <SportsSubscriptionCreateUpdateForm :form="newSportsSubscriptionForm" />
                </template>
				
			</DialogForm>
			
			<DialogForm
				title="Edit Sports Subscription"
				:open="editSportsSubscriptionDialogOpen"
				@close="editSportsSubscriptionDialogOpen = false"
				@submit="() => updateProductSubscriptionById(editSportsSubscriptionForm)"
				:saving="savingSubscription"
			>
				<template v-slot:form-content>
					<SportsSubscriptionCreateUpdateForm :form="editSportsSubscriptionForm" />
				</template>
			
			</DialogForm>
			
			<DialogForm
				title="Create Clinical Subscription"
				:open="createClinicalSubscriptionDialogOpen"
				@close="createClinicalSubscriptionDialogOpen = false"
				@submit="() => updateProductSubscriptionById(newClinicalSubscriptionForm)"
				:saving="savingSubscription"
			>
				<template v-slot:form-content>
					<ClinicalSubscriptionCreateUpdateForm :form="newClinicalSubscriptionForm" />
				</template>
			
			</DialogForm>
			
			<DialogForm
				title="Edit Clinical Subscription"
				:open="editClinicalSubscriptionDialogOpen"
				@close="editClinicalSubscriptionDialogOpen = false"
				@submit="() => updateProductSubscriptionById(editClinicalSubscriptionForm)"
				:saving="savingSubscription"
			>
				<template v-slot:form-content>
					<ClinicalSubscriptionCreateUpdateForm :form="editClinicalSubscriptionForm" />
				</template>
			
			</DialogForm>
            
			<br />
			
			<AppConfirmDialog 
				title="Delete Subscription" 
				:open="deleteSubscriptionDialogOpen"
				submit-button-title="Confirm"
				@confirm="confirmDeleteSubscription"
				@close="deleteSubscriptionDialogOpen = false"
				confirm-delete
				:loading="deletingSubscription"
			>
				<div>
					Are you sure you want to delete Subscription ID #{{subscriptionToDelete ? subscriptionToDelete.productSubscriptionId : null}}?
				</div>
			</AppConfirmDialog>

            <br />

            <AppConfirmDialog
                    title="Create Invoice From Subscription"
                    :open="createSubscriptionInvoiceDialogOpen"
                    submit-button-title="Confirm"
                    @confirm="confirmCreateSubscriptionInvoice"
                    @close="createSubscriptionInvoiceDialogOpen = false"
                    :loading="creatingSubscriptionInvoice"
                    style="width: 650px;"
            >
                <div>
                    Are you sure you want to create an invoice for Subscription #{{subscriptionInvoiceToCreate ? subscriptionInvoiceToCreate.productSubscriptionId : null}}?
                </div>
            </AppConfirmDialog>

        </div>
		<div v-else>
			<app-page-loader :text="'Loading'"></app-page-loader>
		</div>
	</div>

</template>

<script>
import {SET_SNACKBAR, SET_USER} from "@/store/mutation-types";
import 'moment-timezone'
import moment from "moment";
import {billingCycleTypes, clinicalPackageTiers, packageTiers} from "@/js/shared/constants";

import {createInvoiceFromSubscription, deleteProductSubscriptionById} from "@/services/billing.service";
import SportsSubscriptions from "@/js/shared/classes/Subscription/SportsSubscriptions";
import AppButton from "@/components/AppButton";
import SportsSubscriptionCreateUpdateForm
	from "@/components/OrgManagement/Subscription/SportsSubscriptionCreateUpdateForm";
import SportsSubscription from "@/js/shared/classes/Subscription/SportsSubscription";
import ClinicalSubscriptions from "@/js/shared/classes/Subscription/ClinicalSubscriptions";
import ClinicalSubscriptionCreateUpdateForm
	from "@/components/OrgManagement/Subscription/ClinicalSubscriptionCreateUpdateForm";
import ClinicalSubscription from "@/js/shared/classes/Subscription/ClinicalSubscription";
import {createOrUpdateProductSubscriptionById, getAllSubscriptions} from "@/services/billing.service";
import {superAdminSymbol} from "@/js/shared/constants";


export default {
	name: "SubscriptionGeneral",
	props: {
		billingInfo: {
			type: Object,
			default: null
		}
	},
	components: {
		ClinicalSubscriptionCreateUpdateForm,
		SportsSubscriptionCreateUpdateForm,
		AppButton,
	},
	data() {
		return {
            superAdminSymbol,
			model: {
				sports: {
					subscriptionStartDate: null,
					subscriptionEndDate: null,
					billingCycle: null,
                    profileCount: null,
					profilePrice: null,
					packageTier: null,
					systemFee: null,
					isManualBilling: null,
					isDemo: null,
                    productSubscriptionId: null,
                    isFree: null,
                    doNotRenew: null,
                    updateFutureSubscriptions: null
				},
				clinical: {
					subscriptionStartDate: null,
					subscriptionEndDate: null,
					billingCycle: null,
					profileCount: null,
					profilePrice: null,
					packageTier: null,
					systemFee: null,
					isManualBilling: null,
					isDemo: null,
                    productSubscriptionId: null,
                    isFree: null,
                    doNotRenew: null,
                    updateFutureSubscriptions: null
				}
			},
			
			sportsProfileTypes: packageTiers,
			clinicalProfileTypes: clinicalPackageTiers,
			
			organizationName: '',
			isUpcomingSubscription: false,
			isPreviousSubscription: false,
			
			sportsSubscriptionEnabled: false,
			clinicalSubscriptionEnabled: false,
			
			createSports: false,
			createClinical: false,
			
			isDataLoaded: false,
			isDeleteDialogOpen: false,
			isUsageDialogOpen: false,
			
			
			billingCycleTypes,
			// constant
			// billingCycleTypes: billingCycleTypes,
			// clinicalProfileTypes: clinicalPackageTiers,
			// sportsProfileTypes: packageTiers,
			
			createSportsSubscriptionDialogOpen: false,
			editSportsSubscriptionDialogOpen: false,
			deleteSubscriptionDialogOpen: false,
			
			savingSubscription: false,
			deletingSubscription: false,
			subscriptionToDelete: null,
			
			currentSportsTab: 0,
			currentClinicalTab: 0,
			
			createClinicalSubscriptionDialogOpen: false,
			editClinicalSubscriptionDialogOpen: false,

            creatingSubscriptionInvoice: false,
            subscriptionInvoiceToCreate: null,
            createSubscriptionInvoiceDialogOpen: false,
			
			newSportsSubscriptionForm: SportsSubscription.getNewSportsSubscriptionForm(),
			newClinicalSubscriptionForm: ClinicalSubscription.getNewClinicalSubscriptionForm(),
			editSportsSubscriptionForm: null,
			editClinicalSubscriptionForm: null,
			// sportsTabs: [
			// 	{
			// 		label: 'Table',
			// 		icon: 'mdi-format-list-bulleted'
			// 	}
			// ],

			allSportsSubscriptions: [],
			allClinicalSubscriptions: []
		}
	},
	mounted() {
		this.init()
	},
	watch: {
		sportsSubscriptionEnabled: function() {
			if (!this.sportsSubscriptionEnabled && this.model) {
				this.model.sports = null;
			}
			else if (this.model && !this.model.sports) {
				this.model.sports = {};
			}
		},
		clinicalSubscriptionEnabled: function () {
			if (!this.clinicalSubscriptionEnabled && this.model) {
				this.model.clinical = null;
			}
			else if (this.model && !this.model.clinical) {
				this.model.clinical = {};
			}
		},
	},
	methods: {
		init() {
			this.getDataFromApi();
		},
		async getDataFromApi() {

            this.isDataLoaded = false;
			
			// let query = 'isUpcomingSubscription=' + this.isUpcomingSubscription + '&isPreviousSubscription=' + this.isPreviousSubscription;
			// const endpoint = baseUrl + '/Billing/GetProductSubscription?' + query;
			// const response = await httpService.post(endpoint);
			
			// let query2 = 'isSports=' + true;
			// let endpoint2 = baseUrl + '/Billing/GetAllSubscriptions?' + query2;
			// let response2 = await httpService.post(endpoint2);
			
			let response2 = await getAllSubscriptions(true);
			
			
			let sportsSubscriptions = response2.productSubscriptions.map(x => {
				return x.model.sports
			})
			
            //if super admin, just use sportsSubscriptions, if not super admin, just take 1 future and 1 current
			
			this.allSportsSubscriptions = new SportsSubscriptions(sportsSubscriptions);

            //if super admin, just use sportsSubscriptions, if not super admin, just take only 1 of the closest future based on StartDate and 1 current
            // For super admin, show all subscriptions
            if (!this.$store.getters.isSuperAdmin) {
                //console.log('All subscriptions before filtering:', this.allSportsSubscriptions.data);

                const currentSub = this.allSportsSubscriptions.data.find(x => x.isCurrent);
                //console.log('Current subscription:', currentSub);

                const futureSubs = this.allSportsSubscriptions.data.filter(x => x.isFuture);
                //console.log('All future subscriptions:', futureSubs);

                // Debug the dates before sorting
                // console.log('Future subscription dates before sorting:', futureSubs.map(sub => ({
                //     date: sub.startDate.value,
                //     display: sub.startDate.display
                // })));

                // Sort future subscriptions by start date ascending
                const sortedFutureSubs = futureSubs.sort((a, b) => {
                    // Convert string dates to timestamps for comparison
                    const dateA = new Date(a.startDate.value).getTime();
                    const dateB = new Date(b.startDate.value).getTime();
                    return dateA - dateB;
                });

                // Debug the dates after sorting
                // console.log('Future subscription dates after sorting:', sortedFutureSubs.map(sub => ({
                //     date: sub.startDate.value,
                //     display: sub.startDate.display
                // })));

                //console.log('Sorted future subscriptions:', sortedFutureSubs);

                // Take only the first future subscription (closest to current date)
                const nextFutureSub = sortedFutureSubs[0];
                //console.log('Next future subscription:', nextFutureSub);

                // Update the data array with only current and nearest future subscription
                this.allSportsSubscriptions.data = [
                    currentSub,
                    nextFutureSub
                ].filter(Boolean);

                //console.log('Final filtered subscriptions:', this.allSportsSubscriptions.data);
            }

            // let query3 = 'isSports=' + false;
			// let endpoint3 = baseUrl + '/Billing/GetAllSubscriptions?' + query3;
			// let response3 = await httpService.post(endpoint3);
			
			let response3 = await getAllSubscriptions(false)
			
			let clinicalSubscriptions = response3.productSubscriptions.map(x => {
				return x.model.clinical
			})
			
			this.allClinicalSubscriptions = new ClinicalSubscriptions(clinicalSubscriptions);
            
            //if super admin, just use clinicalSubscriptions, if not super admin, just take 1 future and 1 current
            if (!this.$store.getters.isSuperAdmin) {
                const currentSub = this.allClinicalSubscriptions.data.find(x => x.isCurrent);
                const futureSubs = this.allClinicalSubscriptions.data.filter(x => x.isFuture);

                // Sort future subscriptions using timestamp comparison
                const sortedFutureSubs = futureSubs.sort((a, b) => {
                    const dateA = new Date(a.startDate.value).getTime();
                    const dateB = new Date(b.startDate.value).getTime();
                    return dateA - dateB;
                });

                const nextFutureSub = sortedFutureSubs[0];
                this.allClinicalSubscriptions.data = [
                    currentSub,
                    nextFutureSub
                ].filter(Boolean);
            }
			
			// if (response.isSuccess) {
			// 	if (response.model.sports)
			// 		this.sportsSubscriptionEnabled = true;
			//	
			// 	if (response.model.clinical)
			// 		this.clinicalSubscriptionEnabled = true;
			//	
			// 	this.model = response.model;
			// 	this.organizationName = response.organizationName;
			// 	this.isUpcomingSubscription = response.isUpcomingSubscription;
			// 	this.isPreviousSubscription = response.isPreviousSubscription;
			// }
			
			this.isDataLoaded = true;
		},
		async updateProductSubscriptionById(form) {
			this.savingSubscription = true;
			let response = await createOrUpdateProductSubscriptionById(form);
            
			if (response.isSuccess) {
				this.editSportsSubscriptionDialogOpen = false;
				this.createSportsSubscriptionDialogOpen = false;
				this.editClinicalSubscriptionDialogOpen = false;
				this.createClinicalSubscriptionDialogOpen = false;
				this.init();
				this.$store.commit(SET_SNACKBAR, {
					text: 'Subscription Updated Created',
					color: 'success',
					open: true
				});
			}
			this.savingSubscription = false;
		},
		// async createSportsProductSubscription() {
		// 	this.savingSportsSubscription = true;
		// 	const {newSportsSubscriptionForm} = this;
		// 	let request = newSportsSubscriptionForm;
		// 	let response = await createOrUpdateProductSubscriptionById(request);
		// 	if (response.isSuccess) {
		// 		this.createSportsSubscriptionDialogOpen = false;
		// 		this.init()
		// 		this.$store.commit(SET_SNACKBAR, {
		// 			text: 'Subscription Successfully Created',
		// 			color: 'success',
		// 			open: true
		// 		});
		// 	};
		// 	this.savingSportsSubscription = false;
		// },
		formatDate(date) {
			return moment(date).format("M/D/YYYY")
		},
		// async switchToPrevious() {
		// 	this.isUpcomingSubscription = false;
		// 	this.isPreviousSubscription = true;
		// 	this.getDataFromApi();
		// },
		// async switchToCurrent() {
		// 	this.isUpcomingSubscription = false;
		// 	this.isPreviousSubscription = false;
		// 	this.getDataFromApi();
		// },
		// async switchToUpcoming() {
		// 	this.isUpcomingSubscription = true;
		// 	this.isPreviousSubscription = false;
		// 	this.getDataFromApi();
		// },
		editSportsSubscription(subscription) {
			this.editSportsSubscriptionDialogOpen = true;
			let x = subscription;
			this.editSportsSubscriptionForm = subscription.getSubscriptionForm()
		},
		
		editClinicalSubscription(subscription) {
			this.editClinicalSubscriptionDialogOpen = true;
			this.editClinicalSubscriptionForm = subscription.getSubscriptionForm()
		},
		deleteSubscription(subscription) {
			this.deleteSubscriptionDialogOpen = true;
			this.subscriptionToDelete = subscription;
		},
		async confirmDeleteSubscription() {
			this.deletingSubscription = true;
			let response = await deleteProductSubscriptionById(this.subscriptionToDelete?.productSubscriptionId);
			this.deleteSubscriptionDialogOpen = false;
			this.deletingSubscription = false;
			this.init();
			if (response.isSuccess) {
				this.$store.commit(SET_SNACKBAR, {
					text: 'Subscription Deleted',
					color: 'success',
					open: true
				});
			}
		},
        createSubscriptionInvoice(subscription) {
            this.createSubscriptionInvoiceDialogOpen = true;
            this.subscriptionInvoiceToCreate = subscription;
        },
        async confirmCreateSubscriptionInvoice() {
            this.creatingSubscriptionInvoice = true;
            let response = await createInvoiceFromSubscription(this.subscriptionInvoiceToCreate?.productSubscriptionId);
            this.createSubscriptionInvoiceDialogOpen = false;
            this.creatingSubscriptionInvoice = false;
            this.init();
            if (response.isSuccess) {
                this.$store.commit(SET_SNACKBAR, {
                    text: 'Invoice Created',
                    color: 'success',
                    open: true
                });
            }
        }
	},
	computed: {
		billToOrgId() {
			return this.billingInfo ? this.billingInfo.billToOrgId : null;
		},
		billToOrgName() {
			return this.billingInfo ? this.billingInfo.billToOrgName : null;
		},
		canAutoCreateSports() {
			return this.sportsSubscriptionEnabled && this.model.sports && !this.model.sports.isManualBilling && !this.model.sports.isDemo && !this.model.sports.isFree;
		},
		canAutoCreateClinical(){
			return this.clinicalSubscriptionEnabled && this.model.clinical && !this.model.clinical.isManualBilling && !this.model.clinical.isDemo && !this.model.clinical.isFree;
		},
        sportsSubscriptionId(){
            if (this.model && this.model.sports && this.model.sports.productSubscriptionId)
                return "(#"+this.model.sports.productSubscriptionId+")"
            return "";
        },
        clinicalSubscriptionId(){
            if (this.model && this.model.clinical && this.model.clinical.productSubscriptionId)
                return "(#"+this.model.clinical.productSubscriptionId+")"
            return "";
        },
        allClinicalSubscriptionsTableHeaders: function () {

            let clinicalHeaders = [

                {
                    title: 'ID',
                    value: 'productSubscriptionId'
                },
                {
                    title: 'Start Date',
                    value: 'startDate.display'
                },
                {
                    title: 'End Date',
                    value: 'endDate.display',
                },
                {
                    title: 'Name',
                    value: 'displayName'
                },
                {
                    title: 'Profile Count',
                    value: 'profileCount',
                    sortable: false
                },
                {
                    title: 'Total',
                    value: 'total.display'
                },
            ];

            if (this.$store.getters.isSuperAdmin) {
                clinicalHeaders.push({
                    title: 'Actions',
                    value: 'actions',
                    sortable: false
                })
            }

            return clinicalHeaders;
        },
        allSportsSubscriptionsTableHeaders: function () {

            let sportsHeaders = [

                {
                    title: 'ID',
                    value: 'productSubscriptionId'
                },
                {
                    title: 'Start Date',
                    value: 'startDate.display'
                },
                {
                    title: 'End Date',
                    value: 'endDate.display',
                },
                {
                    title: 'Name',
                    value: 'displayName'
                },

                {
                    title: 'Profile Count',
                    value: 'totalProfileCount.display'
                },
                {
                    title: 'Total',
                    value: 'total.display'
                },
            ];

            if (this.$store.getters.isSuperAdmin) {
                sportsHeaders.push({
                    title: 'Actions',
                    value: 'actions',
                    sortable: false
                })
            }

            return sportsHeaders;
        },
        sportsTabs: function () {

            let tabs = [
                {
                    label: 'Table',
                    icon: 'mdi-format-list-bulleted'
                }
            ];

            if (this.$store.getters.isSuperAdmin) {
                tabs.push({
                    label: 'Chart',
                    icon: 'mdi-chart-gantt'
                })
            }

            return tabs;
        }
	}
}

</script>

<style scoped>

</style>

<!--
TODO: remove timestamp from date fields, maybe make date fields use calendar selectors
-->